/** @jsx jsx */
import React from 'react';
import * as typography from '@atlaskit/theme/typography';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { css, jsx } from '@emotion/react';
import { analyticsAttributes, getItemAnalyticsContext, NavigationAnalyticsContext, withAnalyticsContextData } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
import ItemLink from './item-link';
import { AnalyticsItemType } from '../../types';
import Heading from '@atlaskit/heading';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
var switchToSectionContainerStyles = css({
  padding: "var(--ds-space-100, 8px)".concat(" 0")
});
var sectionContainerStyles = css({
  padding: "var(--ds-space-100, 8px)".concat(" ", getBooleanFF('platform.navigation.atlassian-switcher.design-refresh.m2.enabled') ? "var(--ds-space-100, 8px)" : 0)
});
var titleSectionFadeInStyles = css({
  display: 'flex',
  marginLeft: "var(--ds-space-100, 8px)",
  position: 'relative',
  alignItems: 'baseline',
  justifyContent: 'flex-end',
  flexWrap: 'nowrap'
});
var titleSectionFadeInNoMarginStyles = css({
  margin: 0
});
var titleSectionFadeInStandaloneStyles = css({
  marginBottom: "var(--ds-space-100, 8px)"
});
var titleSectionFadeInDrawerStyles = css({
  marginBottom: "var(--ds-space-200, 16px)"
});
var switchToSectionTitleStyles = css({
  marginTop: 0,
  marginBottom: 0,
  flex: '1 1 0%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var switchToSectionContainerTitleStyles = css({
  textTransform: 'uppercase',
  marginLeft: "var(--ds-space-100, 8px)"
});
var secondarySectionTitleBaseStyles = css({
  marginLeft: "var(--ds-space-100, 8px)",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
});
var secondarySectionTitleStandaloneStyles = css({
  marginBottom: "var(--ds-space-050, 4px)"
});
var secondarySectionTitleDrawerStyles = css({
  marginBottom: "var(--ds-space-100, 8px)"
});
export var SectionContainerTitle = function SectionContainerTitle(_ref) {
  var appearance = _ref.appearance,
    title = _ref.title;
  return jsx("div", {
    css: [secondarySectionTitleBaseStyles, appearance === 'standalone' ? secondarySectionTitleStandaloneStyles : secondarySectionTitleDrawerStyles]
  }, jsx(Heading, {
    level: "h100"
  }, title));
};
var SectionContainerComponent = function SectionContainerComponent(props) {
  var title = props.title,
    titleLink = props.titleLink,
    children = props.children,
    appearance = props.appearance,
    actionSubject = props.actionSubject,
    sectionId = props.sectionId;
  return React.Children.toArray(children).some(Boolean) ? jsx("section", {
    css: sectionContainerStyles,
    "data-testid": "".concat(sectionId, "__section")
  }, jsx(FadeIn, null, title && jsx(SectionContainerTitle, {
    appearance: appearance,
    title: title
  }), titleLink && jsx(TitleLink, {
    titleLink: titleLink,
    actionSubject: actionSubject
  })), children) : null;
};
var SwitchToSectionContainerComponent = function SwitchToSectionContainerComponent(props) {
  var title = props.title,
    titleLink = props.titleLink,
    children = props.children,
    appearance = props.appearance,
    actionSubject = props.actionSubject,
    sectionId = props.sectionId;
  return React.Children.toArray(children).some(Boolean) ? jsx("section", {
    css: switchToSectionContainerStyles,
    "data-testid": "".concat(sectionId, "__section")
  }, jsx(FadeIn, {
    css: [titleSectionFadeInStyles, getBooleanFF('platform.navigation.atlassian-switcher.design-refresh.m2.enabled') && titleSectionFadeInNoMarginStyles, appearance === 'standalone' ? titleSectionFadeInStandaloneStyles : titleSectionFadeInDrawerStyles]
  }, title && (getBooleanFF('platform.navigation.atlassian-switcher.design-refresh.m2.enabled') ? jsx("div", {
    css: [switchToSectionContainerTitleStyles, switchToSectionTitleStyles]
  }, jsx(Heading, {
    level: "h300"
  }, title)) : jsx("h1", {
    css: [
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    css(typography.h500()), switchToSectionTitleStyles]
  }, title)), titleLink && jsx(TitleLink, {
    titleLink: titleLink,
    actionSubject: actionSubject
  })), children) : null;
};
var TitleLink = function TitleLink(_ref2) {
  var titleLink = _ref2.titleLink,
    actionSubject = _ref2.actionSubject;
  return jsx(NavigationAnalyticsContext, {
    key: titleLink.key,
    data: getItemAnalyticsContext(0, titleLink.key, AnalyticsItemType.PRODUCT, titleLink.productType)
  }, jsx(ItemLink, {
    href: titleLink.href,
    iconAfter: jsx(ShortcutIcon, {
      size: "small",
      label: ""
    }),
    label: titleLink.label,
    testId: "section-title__link",
    actionSubject: actionSubject
  }));
};
export var SwitchToSectionContainer = withAnalyticsContextData(function (props) {
  return analyticsAttributes({
    group: props.sectionId,
    groupItemsCount: React.Children.count(props.children)
  });
})(SwitchToSectionContainerComponent);
export var SectionContainer = withAnalyticsContextData(function (props) {
  return analyticsAttributes({
    group: props.sectionId,
    groupItemsCount: React.Children.count(props.children)
  });
})(SectionContainerComponent);